<template>
  <div class="el-grid-list">
    <div class="emd-container">
      <div
        class="emd-status-bar"
        :class="statusClass(invite.status.key)"
      ></div>
      <div class="emd-container__content">
        <div class="el-chunk">
          <emd-text
            variation-color="subtle"
            type="label"
            size="tiny"
            tag="h4"
            >{{ $t('invite.detail.status') }}</emd-text
          >
        </div>
        <emd-badge
          :class="statusClass(invite.status.key)"
          :text="invite.status.value"
          >{{ invite.status.value }}</emd-badge
        >
      </div>
    </div>
    <div class="emd-container">
      <div class="emd-container__content">
        <div class="el-chunk">
          <emd-text
            variation-color="subtle"
            type="label"
            size="tiny"
            tag="h4"
            >{{ $t('invite.detail.permission') }}</emd-text
          >
        </div>
        <emd-text
          size="section"
          tag="p"
          >{{ invite.permission }}</emd-text
        >
      </div>
    </div>
    <div class="emd-container">
      <div class="emd-container__content">
        <div class="el-chunk">
          <emd-text
            variation-color="subtle"
            type="label"
            size="tiny"
            tag="h4"
            >{{ $t('invite.detail.created-at') }}</emd-text
          >
        </div>
        <emd-text
          size="section"
          tag="p"
          >{{ invite.created_at }}</emd-text
        >
      </div>
    </div>
    <div
      class="emd-container"
      v-if="!inviteIsCanceled(invite.status.key)"
    >
      <div class="emd-container__content">
        <div class="el-chunk">
          <emd-text
            variation-color="subtle"
            type="label"
            size="tiny"
            tag="h4"
            >{{ $t('invite.detail.expires-at') }}</emd-text
          >
        </div>
        <emd-text
          size="section"
          tag="p"
          >{{ invite.expires_at }}</emd-text
        >
      </div>
    </div>
    <div
      class="emd-container"
      v-if="inviteIsCanceled(invite.status.key)"
    >
      <div class="emd-container__content">
        <div class="el-chunk">
          <emd-text
            variation-color="subtle"
            type="label"
            size="tiny"
            tag="h4"
            >{{ $t('invite.detail.canceled-at') }}</emd-text
          >
        </div>
        <emd-text
          size="section"
          tag="p"
          >{{ invite.canceled_at }}</emd-text
        >
      </div>
    </div>
  </div>
</template>
<script>
import { inviteIsCanceled } from '@/views/Team/Invites/enums/invite-status.enum'
import { statusClass } from '@/filters'
import { EmdText, EmdBadge } from 'emerald-vue/src/components'

export default {
  name: 'InviteDetailGrid',

  props: {
    invite: Object
  },

  components: {
    EmdText,
    EmdBadge
  },

  methods: {
    inviteIsCanceled,
    statusClass
  }
}
</script>
